import { RouterModule, Routes } from '@angular/router';

import { InspectionFolderEditPageComponent } from '../pages/edit.component';
import { InspectionResolver } from '../../utils/inspection.resolver';
import { NewFolderPageComponent } from '../pages/new.component';
import { NgModule } from '@angular/core';
import { SynchronizationResolver } from '../../utils/syncronization.resolver';
import { PermissionGuard } from '../../utils/permission.guard';
import { environment } from '../../../environments/environment';

const appRoute = environment.applicationRoute;

const routes: Routes = [
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver, inspection: InspectionResolver },
    children: [
      { path: appRoute + '/inspections/:inspectionId/sections/:sectionId/folder/new', component: NewFolderPageComponent },
      {
        path: appRoute + '/inspections/:inspectionId/sections/:sectionId/folders/:folderId/edit',
        component: InspectionFolderEditPageComponent
      }
    ]
  },
  {
    path: '',
    resolve: { inspection: InspectionResolver },
    children: [
      {
        path: appRoute + '/templates/:inspectionId/sections/:sectionId/folders/new',
        component: NewFolderPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: appRoute + '/templates/:inspectionId/sections/:sectionId/folders/:folderId/edit',
        component: InspectionFolderEditPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FolderRoutingModule {}
export const routedComponents = [NewFolderPageComponent, InspectionFolderEditPageComponent];
